import React from "react";
import Message from "./Message";
import './Messages.css'
import './Message.css'
import ScrollToBottom from 'react-scroll-to-bottom'

const Messages = ({name, messages}) => {
  return (
    <ScrollToBottom className="messages">
      <div class = "messageBox center colorDark">Messages are end to end encrypted 🔐</div>
     { messages.map((message, i) => (
       // i stands for index 
      <Message key = {i} currentUser={name} name={message.user} text={message.text} />
      ))}
    </ScrollToBottom>
  );
};

export default Messages;
